// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"8539d4b2","551":"f5d6f410","851":"49a4710a"}[chunkId] + ".chunk.js";
};